export enum LessonPageModeEnum {
  PPR = 'PPR',
  EXPLORE = 'EXPLORE',
  PTR = 'PTR',
  PCR = 'PCR',
}
